import React, { lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

import NavBar from "./navbar/NavBar";
import FooterSkeleton from "./footer/FooterSkeleton";
import FooterLayout from "./footer/FooterLayout";
import StickyFooter from "./footer/StickyFooter";

// Lazy load Footer & Sticky Footer
//const FooterLayout = lazy(() => import("./footer/FooterLayout"));
//const StickyFooter = lazy(() => import("./footer/StickyFooter"));

const Layout = () => {
    const { pathname } = useLocation();
    const menuListData = useSelector(state => state.webSetting.menuListData);

    if (!menuListData || menuListData.length === 0) {
        return (
            <div className="w-full min-h-screen flex items-center justify-center">
                <span>Loading content...</span>
            </div>
        );
    }

    return (
        <div className="flex flex-col min-h-screen">
            {/* Navbar */}
            <NavBar />

            {/* Main Content */}
            <main role="main" className="flex-grow">
                <Outlet />
            </main>

            {/* Footer (Lazy + Skeleton fallback to avoid CLS) */}
            <footer className="bg-light min-h-[400px] w-full static bottom-0" aria-label="Site Footer">
            {pathname !== "/products" && (
                <Suspense fallback={<FooterSkeleton />}>
                    <FooterLayout />
                </Suspense>
            )}
            </footer>

            {/* Sticky Footer only on homepage */}
            {pathname === "/" && (
                <Suspense fallback={<div className="w-full h-[60px]"></div>}>
                    <StickyFooter />
                </Suspense>
            )}

            {/* Toast Notifications */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
};

export default Layout;
